import { motion } from "framer-motion";
import { WHY } from "../../lib/content";
import { MaskLine, SectionLabel } from "./Reveal";

export default function WhyChooseUs() {
  return (
    <section id="why" data-testid="why-section" className="bg-paper py-24 lg:py-32">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid lg:grid-cols-12 gap-10 items-end mb-16">
          <div className="lg:col-span-8">
            <SectionLabel>Why Choose Us</SectionLabel>
            <h2 className="font-heading font-extrabold tracking-tight text-ink text-4xl sm:text-5xl lg:text-6xl leading-[1]">
              <MaskLine>Eight reasons</MaskLine>
              <MaskLine delay={0.1}>parents <span className="text-flame">trust us.</span></MaskLine>
            </h2>
          </div>
          <div className="lg:col-span-4">
            <p className="text-ink/60 text-lg leading-relaxed">
              Not just classes — a genuine learning system built on attention, clarity and care.
            </p>
          </div>
        </div>

        <div className="border-t border-ink/10">
          {WHY.map((w, i) => (
            <motion.div
              key={w.t}
              data-testid={`why-item-${i}`}
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-8%" }}
              transition={{ duration: 0.55, delay: (i % 2) * 0.06, ease: [0.16, 1, 0.3, 1] }}
              className="group grid grid-cols-12 gap-4 items-center border-b border-ink/10 py-7 hover:bg-ink hover:text-white transition-colors duration-300 px-2 -mx-2"
            >
              <div className="col-span-2 sm:col-span-1 font-heading font-black text-2xl sm:text-4xl text-ink/15 group-hover:text-flame transition-colors">
                {String(i + 1).padStart(2, "0")}
              </div>
              <h3 className="col-span-10 sm:col-span-5 font-heading font-bold text-xl sm:text-2xl tracking-tight">
                {w.t}
              </h3>
              <p className="col-span-12 sm:col-span-6 text-ink/60 group-hover:text-white/70 text-sm sm:text-base transition-colors">
                {w.d}
              </p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
